import axios from "axios";
import { message as AntdAlert } from "antd";
import { put, takeLatest } from "redux-saga/effects";
import * as actions from "../actions";
import * as constants from "../constants";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import { errorHandler } from "../../../../components/unauthorizeHandler";


export function* handleFetchReportBatches({ data }) {
  try {
    const response = yield axios.get(`${baseURL}/api/v2/admin/report-batches`, {
      params: data,
    });

    const { success, message, data: result } = response.data;

    if (success) {
      yield put(actions.fetchReportBatchesSuccess(result));
    } else {
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchReportBatchesError());
    AntdAlert.error("Something went wrong while fetching report batches!");
    console.error("Fetch error:", error);
  }
}


export function* handleUpdateReportBatches({ data }) {
  try {
    const { id, ...payload } = data;

    const response = yield axios.put(
      `${baseURL}/api/v2/admin/report-batches/${id}`,
      payload
    );

    const { success, message } = response.data;

    if (success) {
      AntdAlert.success(message || "Report batch updated successfully.");
      yield put(actions.updateReportBatchesSuccess(response.data?.data || {}));
    } else {
      AntdAlert.error(message || "Update failed.");
      yield put(actions.updateReportBatchesError(response.data?.data || {}));
    }
  } catch (error) {
    yield put(
      actions.updateReportBatchesError(error?.response?.data?.data || {})
    );
    AntdAlert.error("Something went wrong while updating report batch.");
    console.error("Update error:", error?.response);
  }
}


export function* handleDeleteReportBatches({ id }) {
  try {
    const response = yield axios.delete(
      `${baseURL}/api/v2/admin/report-batches/${id}`
    );

    const { success, message } = response.data;

    if (success) {
      AntdAlert.success(message || "Report batch deleted successfully.");
      yield put(actions.deleteReportBatchesSuccess(id));
    } else {
      AntdAlert.error(message || "Delete failed.");
      yield put(actions.deleteReportBatchesError(id));
    }
  } catch (error) {
    yield put(actions.deleteReportBatchesError(id));
    AntdAlert.error("Something went wrong while deleting report batch.");
    console.error("Delete error:", error?.response);
  }
}


export function* watcherReportBatchesSaga() {
  yield takeLatest(constants.FETCH_REPORT_BATCHES, handleFetchReportBatches);
  yield takeLatest(constants.UPDATE_REPORT_BATCHES, handleUpdateReportBatches);
  yield takeLatest(constants.DELETE_REPORT_BATCHES, handleDeleteReportBatches);
}
